/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SmsParameterType } from './sms-parameter-type';
import {
    SmsParameterTypeFromJSON,
    SmsParameterTypeFromJSONTyped,
    SmsParameterTypeToJSON,
    SmsParameterTypeToJSONTyped,
} from './sms-parameter-type';
import type { SmsParameterPlace } from './sms-parameter-place';
import {
    SmsParameterPlaceFromJSON,
    SmsParameterPlaceFromJSONTyped,
    SmsParameterPlaceToJSON,
    SmsParameterPlaceToJSONTyped,
} from './sms-parameter-place';

/**
 * 
 * @export
 * @interface CustomSmsParameter
 */
export interface CustomSmsParameter {
    /**
     * API parameter key (query/header/body/path)
     * @type {string}
     * @memberof CustomSmsParameter
     */
    key: string;
    /**
     * Where to place the parameter
     * @type {SmsParameterPlace}
     * @memberof CustomSmsParameter
     */
    place: SmsParameterPlace;
    /**
     * Semantic type of the parameter
     * @type {SmsParameterType}
     * @memberof CustomSmsParameter
     */
    type: SmsParameterType;
    /**
     * Static value for EXTRA/AUTH/SENDER_NUMBER types
     * @type {string}
     * @memberof CustomSmsParameter
     */
    staticValue?: string | null;
    /**
     * Flag that checks if the static value should be encrypted
     * @type {boolean}
     * @memberof CustomSmsParameter
     */
    shouldEncrypt?: boolean | null;
}



/**
 * Check if a given object implements the CustomSmsParameter interface.
 */
export function instanceOfCustomSmsParameter(value: object): value is CustomSmsParameter {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('place' in value) || value['place'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function CustomSmsParameterFromJSON(json: any): CustomSmsParameter {
    return CustomSmsParameterFromJSONTyped(json, false);
}

export function CustomSmsParameterFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomSmsParameter {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'place': SmsParameterPlaceFromJSON(json['place']),
        'type': SmsParameterTypeFromJSON(json['type']),
        'staticValue': json['static_value'] == null ? undefined : json['static_value'],
        'shouldEncrypt': json['should_encrypt'] == null ? undefined : json['should_encrypt'],
    };
}

export function CustomSmsParameterToJSON(json: any): CustomSmsParameter {
    return CustomSmsParameterToJSONTyped(json, false);
}

export function CustomSmsParameterToJSONTyped(value?: CustomSmsParameter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'place': SmsParameterPlaceToJSON(value['place']),
        'type': SmsParameterTypeToJSON(value['type']),
        'static_value': value['staticValue'],
        'should_encrypt': value['shouldEncrypt'],
    };
}

